import { render, staticRenderFns } from "./unpublishGrade.vue?vue&type=template&id=9f9066b6&scoped=true&"
import script from "./unpublishGrade.vue?vue&type=script&lang=js&"
export * from "./unpublishGrade.vue?vue&type=script&lang=js&"
import style0 from "./unpublishGrade.vue?vue&type=style&index=0&id=9f9066b6&prod&lang=scss&"
import style1 from "./unpublishGrade.vue?vue&type=style&index=1&id=9f9066b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9066b6",
  null
  
)

export default component.exports